<h1>Companies</h1>
<nav mat-tab-nav-bar [tabPanel]="tabs">
  @for (link of links; track link) {
    <a mat-tab-link (click)="gotoTab(link)"
    [active]="activeLink == link">{{link.title}}</a>
  }
</nav>
@if (activeLink?.title === 'Companies') {
  <app-products-companies></app-products-companies>
}
@if (activeLink?.title === 'Permissions') {
  <app-products-permissions></app-products-permissions>
}
@if (activeLink?.title === 'Subscriptions') {
  <app-products-purchases></app-products-purchases>
}
<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
